(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('AiAssistantMonitoring', AiAssistantMonitoring);

    AiAssistantMonitoring.$inject = ['$http'];

    function AiAssistantMonitoring($http) {
        return {
            getOverview: function() {
                return $http.get('api/admin/ai-assistant-monitoring/overview');
            },
            getDetail: function(conversationKey) {
                return $http.get('api/admin/ai-assistant-monitoring/detail', {
                    params: {
                        conversationKey: conversationKey
                    }
                });
            },
            getSystemCommands: function() {
                return $http.get('api/admin/ai-assistant-monitoring/system-commands');
            }
        };
    }
})();
